import React, { Component } from "react";
import AntdTree, { TreeProps } from "antd/lib/tree";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/tree/style";

const { TreeNode, DirectoryTree } = AntdTree;
export default class Tree extends Component<TreeProps> {
  static TreeNode = TreeNode;
  static DirectoryTree = DirectoryTree;
  render() {
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="Tree"
              {...this.props}
              render={eventprops => (
                <AntdTree {...this.props} {...eventprops}  data-ui-role='Tree'/>
              )}
            ></PagePoint>
          ) : (
            <AntdTree {...this.props} />
          )
        }
      </ConfigConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/tree/index.tsx